import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import { LoaderScreen } from "../../../components/LoaderScreen";
import request from "../../../../Helpers/API";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import { useBox } from "../helper/useBox";
import { GetKey } from "../../ReporteCobranza/Actions/GetContainer";
import FiltroReportes from "../Components/FiltroReportes";
import Swal from "sweetalert2";

export const ReporteTotalCartera = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [clientes, setClientes] = useState([]);
    const [boxstate, setBoxState] = useBox();
    const [totalSaldo, setTotalSaldo] = useState(0);

    // console.log(boxstate)

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    // console.log(boxstate)

    useEffect(() => {
        setBoxState(state)
    }, []);

    useEffect(() => {
        onExecute(state.ejercicio, state.periodo, state.tipo_grafica, state.tipo_cartera, state.estado_cartera, state.responsable_cobranza);
    }, []);

    console.log(boxstate)


    const onExecute = (ejercicio, periodo, tipo_grafica, tipo_cartera, estado_cartera, responsable) => {
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        // localStorage.setItem('ejercicio', boxstate.ejercicio)
        // localStorage.setItem('periodo', boxstate.periodo)
        // console.log(adr, sucursales)
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `DashboardReportes/ReporteGraficaTotal?ejercicio=${ejercicio}&periodo=${periodo}&tipo_grafica=${state.tipo_grafica}&tipo_cartera=${state.tipo_cartera}&estado_cartera=${state.estado_cartera}&responsable_cobranza=${state.responsable}&adr=${adr}&sucursales=${sucursales}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setClientes(result);
                    calcularTotalSaldo(result);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    const calcularTotalSaldo = (clientes) => {
        const total = clientes.reduce((acc, cliente) => acc + (parseFloat(cliente.saldo) || 0), 0);
        setTotalSaldo(total);
    };

    const onGeneraExcel = (ejercicio, periodo) => {
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
          sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
          adr = "0";
        }
        setLoader({ ...loader, mostrar: true });
        request
          .get(`DashboardReportes/ImprimirExcelReporteTotal?ejercicio=${ejercicio}&periodo=${periodo}&tipo_grafica=${state.tipo_grafica}&tipo_cartera=${state.tipo_cartera}&estado_cartera=${state.estado_cartera}&responsable_cobranza=${state.responsable}&adr=${adr}&sucursales=${sucursales}`)
          .then(({ documento, filename }) => {
            const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
            const downloadLink = document.createElement("a");
            const fileName = `${filename}.xlsx`;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
            setLoader({ ...loader, mostrar: false });
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
          });
      };
    
      const onGeneraPDF = (ejercicio, periodo) => {
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
          sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
          adr = "0";
        }
        setLoader({ ...loader, mostrar: true });
        request
          .get(`DashboardReportes/ImprimirPDFReporteTotal?ejercicio=${ejercicio}&periodo=${periodo}&tipo_grafica=${state.tipo_grafica}&tipo_cartera=${state.tipo_cartera}&estado_cartera=${state.estado_cartera}&responsable_cobranza=${state.responsable}&adr=${adr}&sucursales=${sucursales}`)
          .then((result) => {
            setLoader({ ...loader, mostrar: false });
            const linkSource = `data:application/pdf;base64, ${result.documento}`;
            const downloadLink = document.createElement("a");
            const fileName = `${result.nombredocumento}.${result.extension}`;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            Swal.fire("Clientes", JSON.stringify(error), "error");
          });
      };

    return (
        <PlantillaScreen
            titulo={`REPORTE TOTAL DE CARTERA ` + (state.nombre === 'OPERACION' ? 'DE OPERACION' : state.nombre)}
            className_main={1}
            className={"reporte-total-cartera"}
        >
            <LoaderScreen loader={loader} />
            <div className="reporte-total-cartera-actions">
                <div
                    className="reporte-total-cartera-actions-regresar"
                    onClick={() => history.push('/Creditoycobranza/DashboardCobranza')}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="reporte-total-cartera-actions-filtro">
                    <FiltroReportes
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                    />
                </div>
                <div className="buttons">
                    <button className="excel"
                        onClick={() => onGeneraExcel((boxstate.ejercicio), (boxstate.periodo))}
                    >
                        <i className=" icon-file-excel" /> Excel
                    </button>
                    <button className="PDF"
                        onClick={() => onGeneraPDF(boxstate.ejercicio, boxstate.periodo)}
                        style={{ backgroundColor: '#940404' }}>
                        PDF
                    </button>
                </div>
            </div>
            <div className="reporte-total-cartera-container scroll-4">
                <div className="reporte-total-cartera-header">
                    <div className="reporte-total-cartera-header-title">
                        <FormatListNumberedIcon /> Listado de Clientes
                    </div>
                    <div className="contador-convenios-encontrados">
                        Clientes Encontrados: {clientes.length}
                    </div>
                </div>
                <div className="reporte-total-cartera-container-table scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th>Sucursal</th>
                                <th>
                                    <div>Cliente</div>
                                </th>

                                <th>
                                    <div>Vencimiento</div>
                                </th>
                                <th>
                                    <div>Días Vencido</div>
                                </th>
                                <th>
                                    <div>Saldo</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {clientes.map((clt) => (
                                <tr>
                                    <td>{clt.sucursal}</td>
                                    <td>{clt.razon_social}</td>
                                    <td className="ta-center">{new Date(clt.vencimiento).toLocaleDateString()}</td>
                                    <td className="ta-center">{clt.dias_Vencido < 0 ? 0 : clt.dias_Vencido}</td>
                                    <td className="ta-right">{FormatMoney(clt.saldo, 2)}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td className="ta-right" colSpan={3}></td>
                                <td className="ta-right">Total:</td>
                                <td className="ta-right">
                                    {FormatMoney(totalSaldo, 2)}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </PlantillaScreen>
    );
};